import React, {useEffect, useState} from "react";
import "../settings.css";
import {ErrorMessage, Field, Form, Formik} from "formik";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import {
    updatePasswordSchema,
} from "../../../components/schemas/Schemas";
import Switch from "@mui/material/Switch";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import {ApiDetails, KEY, TOTP_ApiDetails} from "../../../Constants";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import CryptoJS from "crypto-js";
import DialogContentText from "@mui/material/DialogContentText";
import {TextField} from "@material-ui/core";
import DialogActions from "@mui/material/DialogActions";
import {DeleteOutline, QrCode, VpnKey, Security, LockOutlined, Shield} from "@mui/icons-material";
import {
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Card,
    CardContent,
    Chip,
    Box,
    Divider,
    Grid
} from "@mui/material";
import { handle401Unauthorized, handle403Forbidden } from '../../../utils/authErrorHandler';
import { getAuthToken } from '../../../services/api/client';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function SecurityComponent(props) {
    // Fix 1: Add error boundary and null checks
    const getDecryptedData = () => {
        try {
            const encryptedData = localStorage.getItem("myMap");
            if (!encryptedData) {
                console.error("No encrypted data found in localStorage");
                return null;
            }

            const myMapDetailsDecrypted = CryptoJS.AES.decrypt(encryptedData, KEY);
            const originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);

            if (!originalText) {
                console.error("Failed to decrypt data or empty result");
                return null;
            }

            return JSON.parse(originalText);
        } catch (error) {
            console.error("Error decrypting data:", error);
            return null;
        }
    };

    const [decryptedData, setDecryptedData] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);

    let initialValues = {
        old_password: "",
        new_password: "",
        confirm_new_password: "", // Fix 2: Add missing field
    };

    const [loading, setLoading] = useState(false);

    const [tokenModal, setTokenModal] = useState(false);
    const [token, setToken] = useState("");
    const handleClose = () => setTokenModal(false);

    const [viewOldPassword, setViewOldPassword] = React.useState(false);
    const [viewNewPassword, setViewNewPassword] = React.useState(false);
    const [viewConfirmNewPassword, setViewConfirmNewPassword] =
        React.useState(false);

    // 2FA/TOTP state
    const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
    const [twoFactorSet, setTwoFactorSet] = useState(false);
    const [setupModal, setSetupModal] = useState(false);
    const [disableModal, setDisableModal] = useState(false);
    const [qrCodeUrl, setQrCodeUrl] = useState("");
    const [qrCodeImage, setQrCodeImage] = useState("");
    const [setupSecret, setSetupSecret] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [loading2FA, setLoading2FA] = useState(false);
    const [loadingDisable2FA, setLoadingDisable2FA] = useState(false);

    // Registration modal state
    const [registrationModal, setRegistrationModal] = useState(false);
    const [registrationData, setRegistrationData] = useState({
        email_address: "",
        password: "",
        user_type: ""
    });
    const [userTypes, setUserTypes] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState(null); // Fix 3: Initialize as null
    const [loadingRegistration, setLoadingRegistration] = useState(false);

    // Fix 4: Safe function to check 2FA status
    const check2FAStatus = () => {
        try {
            if (!decryptedData || !Array.isArray(decryptedData)) {
                console.error("Invalid decrypted data format");
                return;
            }

            // Add null checks for array access
            const twoFactorStatus = decryptedData[17]?.[1];
            const twoFASet = decryptedData[18]?.[1];

            console.log("two_factor_enabled:", twoFactorStatus);
            console.log("two_fa_set:", twoFASet);

            setTwoFactorSet(twoFASet === "YES");
            setTwoFactorEnabled(twoFactorStatus === "YES");
        } catch (error) {
            console.error("Error checking 2FA status:", error);
            setTwoFactorEnabled(false);
        }
    };

    // Fix 5: Improved useEffect with error handling
    useEffect(() => {
        const loadData = async () => {
            try {
                // Load and decrypt data
                const data = getDecryptedData();
                setDecryptedData(data);
                setDataLoaded(true);

                if (data) {
                    check2FAStatus();
                }

                // Fetch user types for registration
                const response = await fetch(ApiDetails + "pegasus/visionary/extras/user_types", {
                    method: "GET",
                });

                if (response.ok) {
                    const userTypesData = await response.json();
                    setUserTypes(userTypesData || []);
                } else {
                    console.error("Failed to fetch user types:", response.status);
                    setUserTypes([]);
                }
            } catch (error) {
                console.error("Error loading data:", error);
                setDataLoaded(true); // Still set to true to prevent infinite loading
                setUserTypes([]);

                // Show error to user if props.snackBar is available
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error loading data. Please refresh the page.",
                        type: "error",
                    });
                }
            }
        };

        loadData();
    }, []); // Fix 6: Remove dependency on decryptedData to prevent infinite loop

    // Fix 7: Re-run 2FA check when decryptedData changes
    useEffect(() => {
        if (decryptedData && dataLoaded) {
            check2FAStatus();
        }
    }, [decryptedData, dataLoaded]);

    // Fix 8: Early return if data not loaded
    if (!dataLoaded) {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}>
                <Typography>Loading...</Typography>
            </div>
        );
    }

    if (!decryptedData) {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}>
                <Typography color="error">Failed to load user data. Please try refreshing the page.</Typography>
            </div>
        );
    }

    const logout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    const register2FAUser = () => {
        if (!registrationData.email_address || !registrationData.password || !selectedUserType) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Please fill in all fields.",
                    type: "error",
                });
            }
            return;
        }

        setLoadingRegistration(true);

        // Step 1: Verify credentials with PMS system
        const loginData = {
            email_address: registrationData.email_address,
            password: registrationData.password,
            user_type: selectedUserType.id
        };

        fetch(ApiDetails + "pegasus/visionary/authorization/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken()
            },
            body: JSON.stringify(loginData),
        })
            .then(async (response) => {
                const pmsData = await response.json();
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    // Step 2: PMS login successful, now register with 2FA system
                    register2FAInTOTPSystem(registrationData.email_address, registrationData.password);
                } else {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Invalid PMS credentials. Please check your login details.",
                            type: "error",
                        });
                    }
                    setLoadingRegistration(false);
                }
            })
            .catch((err) => {
                console.log("PMS login error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error verifying credentials. Please try again.",
                        type: "error",
                    });
                }
                setLoadingRegistration(false);
            });
    };

    const register2FAInTOTPSystem = (email, password) => {
        // Step 3: Register user in TOTP system
        const totpRegistrationData = {
            username: email,
            email: email,
            password: password
        };

        fetch(TOTP_ApiDetails + "/api/auth/register", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(totpRegistrationData),
        })
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {
                    // Step 4: User registered in TOTP system, now enable 2FA
                    enable2FAForUser(email);
                } else {
                    const errorData = await response.json();
                    if (errorData.message && errorData.message.includes("already exists")) {
                        // User already exists in TOTP system, proceed to enable 2FA
                        enable2FAForUser(email);
                    } else {
                        if (props.snackBar) {
                            props.snackBar({
                                text: "Error registering for 2FA system. Please try again.",
                                type: "error",
                            });
                        }
                        setLoadingRegistration(false);
                    }
                }
            })
            .catch((err) => {
                console.log("TOTP registration error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error connecting to 2FA system. Please try again.",
                        type: "error",
                    });
                }
                setLoadingRegistration(false);
            });
    };

    const enable2FAForUser = (email) => {
        // Step 5: Enable 2FA and get QR code
        fetch(TOTP_ApiDetails + "/api/auth/2fa/enable", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    const data = await response.json();
                    setQrCodeUrl(data.qrCodeUrl);
                    setQrCodeImage(data.qrCodeImage);
                    setSetupSecret(data.manualEntryKey);
                    setRegistrationModal(false);
                    setSetupModal(true);
                    setLoadingRegistration(false);

                    // Clear registration data
                    setRegistrationData({
                        email_address: "",
                        password: "",
                        user_type: ""
                    });
                    setSelectedUserType(null);
                } else {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Error enabling 2FA. Please try again.",
                            type: "error",
                        });
                    }
                    setLoadingRegistration(false);
                }
            })
            .catch((err) => {
                console.log("2FA enable error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error enabling 2FA. Please try again.",
                        type: "error",
                    });
                }
                setLoadingRegistration(false);
            });
    };

    const verify2FASetup = () => {
        if (verificationCode.trim().length !== 6) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Please enter a valid 6-digit code.",
                    type: "error",
                });
            }
            return;
        }

        setLoading2FA(true);

        // Fix 9: Safe access to decrypted data
        const userEmail = decryptedData[5]?.[1];
        if (!userEmail) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Error: User email not found.",
                    type: "error",
                });
            }
            setLoading2FA(false);
            return;
        }

        // Verify with TOTP system
        fetch(TOTP_ApiDetails + "/api/auth/2fa/verify-setup", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                code: verificationCode,
                email: userEmail
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    // Step 6: Update PMS system to reflect 2FA is enabled
                    updatePMS2FAStatus(true);
                } else {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Invalid verification code. Please try again.",
                            type: "error",
                        });
                    }
                    setLoading2FA(false);
                }
            })
            .catch((err) => {
                console.log("2FA verification error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error verifying code. Please try again.",
                        type: "error",
                    });
                }
                setLoading2FA(false);
            });
    };

    const updatePMS2FAStatus = (enabled) => {
        // Fix 10: Safe access to landlord_id
        const landlordId = decryptedData[0]?.[1];
        if (!landlordId) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Error: Landlord ID not found.",
                    type: "error",
                });
            }
            setLoading2FA(false);
            setLoadingDisable2FA(false);
            return;
        }

        // Update PMS system to reflect 2FA status
        fetch(ApiDetails + "pegasus/visionary/authorization/2fa", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken()
            },
            body: JSON.stringify({
                landlord_id: landlordId,
                two_factor_enabled: enabled ? "YES" : "NO"
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    setTwoFactorEnabled(enabled);
                    setSetupModal(false);
                    setDisableModal(false);
                    setVerificationCode("");
                    if (props.snackBar) {
                        props.snackBar({
                            text: enabled ? "2FA enabled successfully!" : "2FA disabled successfully.",
                            type: "success",
                        });
                    }
                    setLoading2FA(false);
                    setLoadingDisable2FA(false);
                    logout();
                } else {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Error updating 2FA status. Please try again.",
                            type: "error",
                        });
                    }
                    setLoading2FA(false);
                    setLoadingDisable2FA(false);
                }
            })
            .catch((err) => {
                console.log("PMS 2FA status update error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error updating system. Please try again.",
                        type: "error",
                    });
                }
                setLoading2FA(false);
                setLoadingDisable2FA(false);
            });
    };

    const disable2FA = () => {
        if (verificationCode.trim().length !== 6) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Please enter a valid 6-digit code to disable 2FA.",
                    type: "error",
                });
            }
            return;
        }

        setLoadingDisable2FA(true);

        const userEmail = decryptedData[5]?.[1];
        if (!userEmail) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Error: User email not found.",
                    type: "error",
                });
            }
            setLoadingDisable2FA(false);
            return;
        }

        // Disable in TOTP system first
        fetch(TOTP_ApiDetails + "/api/auth/2fa/disable", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                code: verificationCode,
                email: userEmail,
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    // Update PMS system
                    updatePMS2FAStatus(false);
                } else {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Invalid verification code. Please try again.",
                            type: "error",
                        });
                    }
                    setLoadingDisable2FA(false);
                }
            })
            .catch((err) => {
                console.log("2FA disable error:", err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Error disabling 2FA. Please try again.",
                        type: "error",
                    });
                }
                setLoadingDisable2FA(false);
            });
    };

    const setup2FA = () => {
        // Instead of directly setting up 2FA, show registration modal first
        setRegistrationModal(true);
    };

    const handleRegistrationClose = () => {
        setRegistrationModal(false);
        setRegistrationData({
            email_address: "",
            password: "",
            user_type: ""
        });
        setSelectedUserType(null);
    };

    const handleSetupClose = () => {
        setSetupModal(false);
        setVerificationCode("");
        setQrCodeUrl("");
        setSetupSecret("");
    };

    const handleDisableClose = () => {
        setDisableModal(false);
        setVerificationCode("");
    };

    const handleClickShowPassword = () => {
        setViewOldPassword(!viewOldPassword);
    };
    const handleClickShowNewPassword = () => {
        setViewNewPassword(!viewNewPassword);
    };
    const handleClickShowConfirmNewPassword = () => {
        setViewConfirmNewPassword(!viewConfirmNewPassword);
    };
    const handleMouseDownPassword = (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();
    };

    const updatePassword = (values) => {
        setLoading(true);

        const userEmail = decryptedData[5]?.[1];
        if (!userEmail) {
            if (props.snackBar) {
                props.snackBar({
                    text: "Error: User email not found.",
                    type: "error",
                });
            }
            setLoading(false);
            return;
        }

        const body = {
            old_password: values.old_password,
            new_password: values.new_password,
            email_address: userEmail,
        };

        fetch(ApiDetails + "pegasus/visionary/authorization/update/password", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken()
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Password Updated Successfully.",
                            type: "success",
                        });
                    }
                    setLoading(false);

                    localStorage.clear();
                    window.location.href = "/";
                } else if (response.status === 401) {
                    if (props.snackBar) {
                        props.snackBar({
                            text: "Incorrect Old Password Provided.",
                            type: "error",
                        });
                    }
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                if (props.snackBar) {
                    props.snackBar({
                        text: "Something Went Wrong. Try Again Later",
                        type: "error",
                    });
                }
                setLoading(false);
            });
    };

    return (
        <Box sx={{ maxWidth: '100%'}}>
            {/* Page Header */}
            <Box sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Shield sx={{ fontSize: 32, color: '#398DD2', mr: 1.5 }} />
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                        Security Settings
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: '#6c757d', ml: 5.5 }}>
                    Manage your account security and authentication preferences
                </Typography>
            </Box>

            {/* 2FA Setup Modal */}
            <Dialog
                open={setupModal}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{color: "#398DD2"}}>
                    <Security style={{marginRight: "10px"}}/>
                    Setup Two-Factor Authentication
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography style={{marginBottom: "20px"}}>
                            Scan the QR code below with your mobile authenticator app, then enter the 6-digit code to
                            complete setup.
                        </Typography>

                        {qrCodeImage && (
                            <div style={{textAlign: "center", marginBottom: "20px"}}>
                                <img
                                    src={qrCodeImage.startsWith('data:') ? qrCodeImage : `data:image/png;base64,${qrCodeImage}`}
                                    alt="2FA QR Code"
                                    style={{maxWidth: "200px", maxHeight: "200px"}}
                                />
                            </div>
                        )}

                        <Typography variant="body2" style={{marginBottom: "10px", color: "#666"}}>
                            Manual entry key: {setupSecret}
                        </Typography>

                        <TextField
                            label="Enter 6-digit code"
                            variant="outlined"
                            fullWidth
                            value={verificationCode}
                            onChange={(event) => setVerificationCode(event.target.value)}
                            inputProps={{maxLength: 6}}
                            style={{marginTop: "10px"}}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSetupClose}>
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={verify2FASetup}
                        loading={loading2FA}
                        startIcon={<VpnKey/>}
                        style={{color: "green"}}
                        loadingPosition="start"
                    >
                        Verify & Enable
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {/* 2FA Disable Modal */}
            <Dialog
                open={disableModal}
                TransitionComponent={Transition}
                keepMounted
            >
                <DialogTitle style={{color: "orange"}}>
                    Disable Two-Factor Authentication
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography style={{marginBottom: "20px"}}>
                            Enter your current 6-digit authentication code to disable 2FA.
                        </Typography>

                        <TextField
                            label="Enter 6-digit code"
                            variant="outlined"
                            fullWidth
                            value={verificationCode}
                            onChange={(event) => setVerificationCode(event.target.value)}
                            inputProps={{maxLength: 6}}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDisableClose}>
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={disable2FA}
                        loading={loadingDisable2FA}
                        startIcon={<DeleteOutline/>}
                        style={{color: "red"}}
                        loadingPosition="start"
                    >
                        Disable 2FA
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {/* 2FA Registration Modal */}
            <Dialog
                open={registrationModal}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{color: "#398DD2"}}>
                    <Security style={{marginRight: "10px"}}/>
                    Register for Two-Factor Authentication
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography style={{marginBottom: "20px"}}>
                            To enable 2FA, please verify your PMS credentials. This will register you in our secure
                            authentication system.
                        </Typography>

                        <TextField
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            type="email"
                            value={registrationData.email_address}
                            onChange={(event) => setRegistrationData({
                                ...registrationData,
                                email_address: event.target.value
                            })}
                            style={{marginBottom: "15px"}}
                        />

                        <TextField
                            label="Password"
                            variant="outlined"
                            fullWidth
                            type="password"
                            value={registrationData.password}
                            onChange={(event) => setRegistrationData({
                                ...registrationData,
                                password: event.target.value
                            })}
                            style={{marginBottom: "15px"}}
                        />

                        <FormControl fullWidth variant="outlined" style={{marginBottom: "15px"}}>
                            <InputLabel>Account Type</InputLabel>
                            <Select
                                value={selectedUserType?.description || ""}
                                onChange={(event) => {
                                    const selected = userTypes.find(type => type.description === event.target.value);
                                    setSelectedUserType(selected);
                                }}
                                label="Account Type"
                            >
                                {userTypes.map((type) => (
                                    <MenuItem key={type.id} value={type.description}>
                                        {type.description}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Typography variant="body2" style={{color: "#666", marginTop: "10px"}}>
                            We'll verify these credentials with your PMS account before enabling 2FA.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleRegistrationClose}>
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={register2FAUser}
                        loading={loadingRegistration}
                        startIcon={<VpnKey/>}
                        style={{color: "green"}}
                        loadingPosition="start"
                    >
                        Verify & Continue
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {/* Password Change Card */}
            <Card
                sx={{
                    mb: 3,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    borderRadius: 2,
                    transition: 'box-shadow 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
                    }
                }}
            >
                <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <LockOutlined sx={{ fontSize: 24, color: '#398DD2', mr: 1.5 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                            Change Password
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: '#6c757d', mb: 3 }}>
                        Update your password regularly to keep your account secure
                    </Typography>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={updatePasswordSchema}
                        onSubmit={updatePassword}
                    >
                        {(formikProps) => (
                            <Form noValidate>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#495057' }}>
                                            Old Password
                                        </Typography>
                                        <Field
                                            as={OutlinedInput}
                                            id="outlined-adornment-old-password"
                                            type={viewOldPassword ? "text" : "password"}
                                            name="old_password"
                                            fullWidth
                                            placeholder="Enter your current password"
                                            error={formikProps.errors.old_password && formikProps.touched.old_password}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: '#398DD2',
                                                    }
                                                }
                                            }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {viewOldPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        {formikProps.errors.old_password && formikProps.touched.old_password && (
                                            <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
                                                <ErrorMessage name="old_password"/>
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#495057' }}>
                                            New Password
                                        </Typography>
                                        <Field
                                            as={OutlinedInput}
                                            id="outlined-adornment-new-password"
                                            type={viewNewPassword ? "text" : "password"}
                                            name="new_password"
                                            fullWidth
                                            placeholder="Enter new password"
                                            error={formikProps.errors.new_password && formikProps.touched.new_password}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: '#398DD2',
                                                    }
                                                }
                                            }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowNewPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {viewNewPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        {formikProps.errors.new_password && formikProps.touched.new_password && (
                                            <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
                                                <ErrorMessage name="new_password"/>
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#495057' }}>
                                            Confirm New Password
                                        </Typography>
                                        <Field
                                            as={OutlinedInput}
                                            id="outlined-adornment-confirm-password"
                                            type={viewConfirmNewPassword ? "text" : "password"}
                                            name="confirm_new_password"
                                            fullWidth
                                            placeholder="Confirm new password"
                                            error={
                                                formikProps.errors.confirm_new_password &&
                                                formikProps.touched.confirm_new_password
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: '#398DD2',
                                                    }
                                                }
                                            }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowConfirmNewPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {viewConfirmNewPassword ? (
                                                            <VisibilityOff/>
                                                        ) : (
                                                            <Visibility/>
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        {formikProps.errors.confirm_new_password && formikProps.touched.confirm_new_password && (
                                            <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
                                                <ErrorMessage name="confirm_new_password"/>
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>

                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                                    <LoadingButton
                                        type="submit"
                                        loading={loading}
                                        startIcon={<SendIcon/>}
                                        variant="contained"
                                        sx={{
                                            bgcolor: '#398DD2',
                                            px: 4,
                                            py: 1,
                                            textTransform: 'none',
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            borderRadius: 2,
                                            '&:hover': {
                                                bgcolor: '#2c6ba0'
                                            }
                                        }}
                                        loadingPosition="start"
                                    >
                                        Update Password
                                    </LoadingButton>
                                </Box>
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>

            {/* Two-Factor Authentication Card */}
            <Card
                sx={{
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    borderRadius: 2,
                    transition: 'box-shadow 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
                    }
                }}
            >
                <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                        <Box sx={{ flex: 1, minWidth: '250px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                <Security sx={{ fontSize: 24, color: '#398DD2', mr: 1.5 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                    Two-Factor Authentication
                                </Typography>
                                {twoFactorEnabled && (
                                    <Chip
                                        label="Active"
                                        size="small"
                                        sx={{
                                            ml: 1.5,
                                            bgcolor: '#d4edda',
                                            color: '#155724',
                                            fontWeight: 600,
                                            fontSize: '11px'
                                        }}
                                    />
                                )}
                            </Box>
                            <Typography variant="body2" sx={{ color: '#6c757d', lineHeight: 1.6 }}>
                                {twoFactorEnabled
                                    ? "Your account is protected with an additional security layer. Use your authenticator app to sign in."
                                    : "Enhance your account security by enabling two-factor authentication. You'll need an authenticator app to complete setup."
                                }
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            {twoFactorSet && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={twoFactorEnabled}
                                            onChange={(event) => {
                                                if (twoFactorSet && twoFactorEnabled) {
                                                    console.log("Disabling 2FA")
                                                    setDisableModal(true);
                                                } else if (!twoFactorEnabled) {
                                                    console.log("Enabling 2FA")
                                                    enable2FAForUser(decryptedData[5]?.[1])
                                                }
                                            }}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#398DD2',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#398DD2',
                                                },
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            {twoFactorEnabled ? "Enabled" : "Disabled"}
                                        </Typography>
                                    }
                                />
                            )}

                            {!twoFactorSet && (
                                <LoadingButton
                                    loading={loading2FA}
                                    onClick={setup2FA}
                                    startIcon={<QrCode/>}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#398DD2',
                                        px: 3,
                                        py: 1,
                                        textTransform: 'none',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        borderRadius: 2,
                                        '&:hover': {
                                            bgcolor: '#2c6ba0'
                                        }
                                    }}
                                    loadingPosition="start"
                                >
                                    Setup 2FA
                                </LoadingButton>
                            )}
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}